import { useEffect } from 'react';

interface IProps {
  totalAmount: number;
  onPaymentApproved: (data: any, details: any) => void;
  onPaymentApproving: () => void;
  onPaymentRejected: () => void;
}

function PayPalButton(props: IProps) {
  const style = {
    layout: 'horizontal',
    color: 'gold',
    shape: 'rect',
    label: 'pay',
    tagline: false,
    size: 'responsive',
  };

  const onApprove = (data: any, actions: any) => {
    props.onPaymentApproved(data, {});
  };

  const createOrder = (_: any, actions: any) => {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: props.totalAmount.toFixed(2),
          },
        },
      ],
    });
  };

  useEffect(() => {
    const el = document.getElementById('paypal-button-container');
    if (el?.hasChildNodes()) {
      return;
    }
    //@ts-ignore
    paypal
      .Buttons({
        createOrder: createOrder,
        onApprove: onApprove,
        style: style,
      })
      .render('#paypal-button-container');
  }, []);

  return <div id="paypal-button-container" />;
}

export { PayPalButton };
